// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "platforms" + "." + "7bb840b1" + ".js";
};